import { RouteObject } from 'react-router-dom'

const accountant: RouteObject[] = [
  {
    path: '/contador',
    async lazy() {
      const { default: Component } = await import('pages/Accountant')
      return { Component }
    },
  },
]

export default accountant
